import { render, staticRenderFns } from "./spaceImageLoading.vue?vue&type=template&id=371d1e7a&scoped=true&"
import script from "./spaceImageLoading.vue?vue&type=script&lang=js&"
export * from "./spaceImageLoading.vue?vue&type=script&lang=js&"
import style0 from "./spaceImageLoading.vue?vue&type=style&index=0&id=371d1e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d1e7a",
  null
  
)

export default component.exports